var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import LanguageSwitch from '@/components/language-switch/LanguageSwitch';
import { identifyHostname, identifyApplication } from '@/support/Client';
import axios from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import i18n from '@/i18n';
let ForgotPassword = class ForgotPassword extends Vue {
    constructor() {
        super(...arguments);
        this.apiServer = identifyHostname() || '';
        this.valid = true;
        this.email = '';
        this.emailRules = [(v) => !!v || 'Email is required', (v) => /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(v) || 'E-mail must be valid'];
        this.isSubmitted = false;
    }
    submit() {
        if (!this.email) {
            return;
        }
        const payload = {
            email: this.email,
        };
        const headers = {};
        if (window.location.hostname !== 'localhost') {
            headers['X-Application'] = identifyApplication();
            headers['Accept-Language'] = i18n.locale;
        }
        const client = axios.create({
            baseURL: this.apiServer,
            headers,
        });
        client
            .post('/v3/forgot-password', payload)
            .then((response) => {
            this.isSubmitted = true;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
};
ForgotPassword = __decorate([
    Component({
        components: {
            LanguageSwitch,
        },
    })
], ForgotPassword);
export default ForgotPassword;
